import React from 'react';
import PropTypes from 'prop-types';
import { push, orderStatusEnum } from '../../utils';
import { vote, addShop } from '../../operates';
import { alert, toast } from '../../components';
import { NoPaginationList } from '../../model';

// 订单状态
export const _headerStatus = (orderStatus: any, virtual: any): string => {
    let str: string = '';
    switch (orderStatus) {
        case orderStatusEnum.DELETE:
            str = '已删除';
            break;
        case orderStatusEnum.CANCEL:
            str = '已取消';
            break;
        case orderStatusEnum.WAIT_PAY:
            str = '待支付';
            break;
        case orderStatusEnum.WAIT_SEND:
            str = virtual ? '充值中' : '待发货';
            break;
        case orderStatusEnum.WAIT_RECEIVE:
            str = virtual ? '充值中' : '待收货';
            break;
        case orderStatusEnum.SUCCESS:
        case orderStatusEnum.SUCCESSSEVEN:
        case orderStatusEnum.SUCCESSSEVENFIC:
            str = '已完成';
            break;
        case orderStatusEnum.TAKE_DELIVERY:
            str = virtual ? '充值成功' : '已收货';
            break;
        case orderStatusEnum.APPLY_REFUND:
            str = virtual ? '充值失败退款中' : '退款处理中';
            break;
        case orderStatusEnum.REFUSE_REFUND:
            str = '拒绝退款';
            break;
        case orderStatusEnum.CONFIRM_REFUND:
            str = '已退款';
            break;
    }
    return str;
};

// 订单头部组件
export const OrderStatusComp = (props: any): JSX.Element => {
    return (
        <p>
            订单编号:
            <span>{props.data.orderId}</span>
            <span className={`${props.prefixCls}state`}>{_headerStatus(props.data.orderStatus, props.data.virtual)}</span>
        </p>
    );
};

// 订单底部组建
export const Footer = (props: any): JSX.Element => {
    const data: any = props.data;
    return (
        <div className={`${props.prefixCls}footer`}>
            <div className={`${props.prefixCls}all`}>
                <span className={`${props.prefixCls}number`}>共 {data.num} 件商品</span>
                总计 ¥{data.price && data.price.toFixed(2)}
            </div>
            <div className={`${props.prefixCls}btn-box`}>
                <div>
                    {
                        data.virtual ?
                            <div>
                                {
                                    (data.orderStatus === orderStatusEnum.CANCEL)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}again same_div`}
                                            onClick={() => {
                                                props.onRePurchase(props.index);
                                            }}
                                        >
                                            重新购买
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.CANCEL && (
                                        <div
                                            className={`${props.prefixCls}delete same_div`}
                                            onClick={() => {
                                                props.onDelete(props.index);
                                            }}
                                        >
                                            删除订单
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                        <div
                                            className={`${props.prefixCls}pay same_div`}
                                            onClick={() => {
                                                props.onPay(props.index);
                                            }}
                                        >
                                            去支付 {data.myData}
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                        <div
                                            className={`${props.prefixCls}cancel same_div`}
                                            onClick={() => {
                                                props.onCancel(props.index);
                                            }}
                                        >
                                            取消订单
                                        </div>
                                    )
                                }
                                {
                                    (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND || data.orderStatus !== orderStatusEnum.COMMENTED)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}confirm same_div`}
                                            onClick={() => {
                                                this.onPush('/addReturnOrder?originPageId=order')
                                            }}
                                        >
                                            申请退款
                                        </div>
                                    )
                                }
                                {
                                    (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus !== orderStatusEnum.COMMENTED)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <span className={`${props.prefixCls}confirm same_div`} onClick={() => { self.location.href = 'https://f3809eff00fcc962.kf5.com/kchat/1040267#/chatbox' }}>联系客服</span>
                                    )
                                }
                                {
                                    (data.orderStatus === orderStatusEnum.TAKE_DELIVERY || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.CONFIRM_REFUND)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}again same_div`}
                                            onClick={() => {
                                                props.onRePurchase(props.index);
                                            }}
                                        >
                                            再次购买
                                        </div>
                                    )
                                }
                            </div>
                            :
                            <div>
                                {
                                    (data.orderStatus === orderStatusEnum.CANCEL || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.SUCCESSSEVEN || data.orderStatus === orderStatusEnum.TAKE_DELIVERY)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}again same_div`}
                                            onClick={() => {
                                                props.onRePurchase(props.index);
                                            }}
                                        >
                                            再次购买
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.CANCEL && (
                                        <div
                                            className={`${props.prefixCls}delete same_div`}
                                            onClick={() => {
                                                props.onDelete(props.index);
                                            }}
                                        >
                                            删除订单
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                        <div
                                            className={`${props.prefixCls}pay same_div`}
                                            onClick={() => {
                                                props.onPay(props.index);
                                            }}
                                        >
                                            去支付 {data.myData}
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                        <div
                                            className={`${props.prefixCls}cancel same_div`}
                                            onClick={() => {
                                                props.onCancel(props.index);
                                            }}
                                        >
                                            取消订单
                                        </div>
                                    )
                                }
                                {
                                    (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND || data.orderStatus === orderStatusEnum.CONFIRM_REFUND)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}confirm same_div`}
                                            onClick={() => {
                                                // props.onReturn(props.data, props.index);
                                                this.onPush('/addReturnOrder?originPageId=order')
                                            }}
                                        >
                                            申请退款
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_SEND && data.updateStatus === 0 && (
                                        <div
                                            className={`${props.prefixCls}editAddress same_div`}
                                            onClick={() => {
                                                props.onEditAddress(data, props.index);
                                            }}
                                        >
                                            修改地址 {data.myDataAddress}
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                                        <div
                                            className={`${props.prefixCls}confirm same_div`}
                                            onClick={() => {
                                                props.onAffirm(props.index);
                                            }}
                                        >
                                            确认收货
                                        </div>
                                    )
                                }
                                {
                                    data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                                        <div
                                            className={`${props.prefixCls}flow same_div`}
                                            onClick={() => {
                                                props.onShow(data, props.index);
                                            }}
                                        >
                                            查看物流
                                        </div>
                                    )
                                }
                            </div>
                    }
                </div>
            </div>
        </div>
    );
};

export class FooterNew extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props, context) {
        super(props, context)
    }
    onPush = (url) => {
        let that = this as any
        window.sessionStorage.setItem('orderData', JSON.stringify(that.props.props.data))
        push(url, that.props)
    }
    onPayShow = () => {
        let that = this as any
        let props = that.props.props
        localStorage.setItem("payData", JSON.stringify(props.data))
        let orderUrl = window.location.hash.slice(3, window.location.hash.length)
        push(`/payType?originPageId=${orderUrl}`, that)
    }
    render() {
        let that = this as any
        let props = that.props.props
        let data = props.data
        return (
            <div className={`${props.prefixCls}footer`}>
                <div className={`${props.prefixCls}all`}>
                    <span className={`${props.prefixCls}number`}>共 {data.num} 件商品</span>
                总计 ¥{data.price && data.price.toFixed(2)}
                </div>
                <div className={`${props.prefixCls}btn-box`}>
                    <div>
                        <div>
                            {
                                (data.orderStatus === orderStatusEnum.CANCEL)
                                && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                    <div
                                        className={`${props.prefixCls}again same_div`}
                                        onClick={() => {
                                            props.onRePurchase(props.index);
                                        }}
                                    >
                                        重新购买
                                    </div>
                                )
                            }
                            {
                                data.orderStatus === orderStatusEnum.CANCEL && (
                                    <div
                                        className={`${props.prefixCls}delete same_div`}
                                        onClick={() => {
                                            props.onDelete(props.index);
                                        }}
                                    >
                                        删除订单
                                    </div>
                                )
                            }
                            {
                                data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                    <div
                                        className={`${props.prefixCls}pay same_div`}
                                        onClick={() => {
                                            // props.onPay(props.index);
                                            // this.setState({
                                            //     isPay: true
                                            // })
                                            this.onPayShow()
                                        }}
                                    >
                                        去支付 {data.myData}
                                    </div>
                                )
                            }
                            {
                                data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                    <div
                                        className={`${props.prefixCls}cancel same_div`}
                                        onClick={() => {
                                            props.onCancel(props.index);
                                        }}
                                    >
                                        取消订单
                                    </div>
                                )
                            }
                            {
                                data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                                    <div
                                        className={`${props.prefixCls}confirm same_div`}
                                        onClick={() => {
                                            props.onAffirm(props.index);
                                        }}
                                    >
                                        确认收货
                                    </div>
                                )
                            }
                            {
                                data.orderType === 1 || data.isDay7 == 0 ?
                                    (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND)
                                    && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                        <div
                                            className={`${props.prefixCls}confirm same_div`}
                                            onClick={() => {
                                                this.onPush('/addReturnOrder?originPageId=order')
                                            }}
                                        >
                                            申请退款
                                        </div>
                                    )
                                    : null
                            }
                            {
                                (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND || data.orderStatus === orderStatusEnum.TAKE_DELIVERY || data.orderStatus === orderStatusEnum.COMMENTED)
                                && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                    <span className={`${props.prefixCls}confirm same_div`} onClick={() => { self.location.href = 'https://f3809eff00fcc962.kf5.com/kchat/1040267#/chatbox' }}>联系客服</span>
                                )
                            }
                            {
                                (data.orderStatus === orderStatusEnum.TAKE_DELIVERY || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.CONFIRM_REFUND)
                                && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                    <div
                                        className={`${props.prefixCls}again same_div`}
                                        onClick={() => {
                                            props.onRePurchase(props.index);
                                        }}
                                    >
                                        再次购买
                                    </div>
                                )
                            }
                            {
                                data.orderStatus === orderStatusEnum.WAIT_SEND && data.updateStatus === 0 && (
                                    <div
                                        className={`${props.prefixCls}editAddress same_div`}
                                        onClick={() => {
                                            props.onEditAddress(data, props.index);
                                        }}
                                    >
                                        修改地址 {data.myDataAddress}
                                    </div>
                                )
                            }
                            {
                                data.orderType == 1 && (data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.TAKE_DELIVERY) && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                    <span className='same_div' style={{ color: '#333', border: '.1rem solid #333' }}
                                        onClick={() => {
                                            props.onShow(data, props.index);
                                        }}>查看物流</span>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
// 订单详情底部按钮
export const OrderDetailFooter = (props): JSX.Element => {
    const data = props.data;
    const prefixCls: string = props.prefixCls;
    return (
        <div className={`${prefixCls}footerBtn`}>
            {
                data.virtual ?
                    <div>
                        {
                            data.orderStatus === orderStatusEnum.CANCEL && (
                                <span
                                    className='same_span'
                                    onClick={() => props.onDeleteShow(data)}>
                                    删除订单
                                </span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.CANCEL
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => {
                                    props.onRePurchase(data);
                                }}>
                                    重新购买
                                </span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                <span onClick={() => props.onCancelShow(data)} className='same_span'>
                                    取消订单
                                </span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => {
                                    props.onPayShow(data);
                                }}>去支付 {props.myData}</span>
                            )
                        }
                        {
                            (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND)
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={props.onReturn}>联系客服</span>
                                // <span className={`${prefixCls}orange same_span`} onClick={() => this.onPush('/addReturnOrder?originPageId=order')}>申请退款</span>
                            )
                        }
                        {
                            (data.orderStatus === orderStatusEnum.TAKE_DELIVERY || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.CONFIRM_REFUND)
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => {
                                    props.onRePurchase(data);
                                }}>
                                    再次购买
                                </span>
                            )
                        }
                    </div>
                    :
                    <div>
                        {
                            data.orderStatus === orderStatusEnum.CANCEL && (
                                <span
                                    className='same_span'
                                    onClick={() => props.onDeleteShow(data)}>
                                    删除订单
                                </span>
                            )
                        }
                        {
                            (data.orderStatus === orderStatusEnum.CANCEL || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.SUCCESSSEVEN || data.orderStatus === orderStatusEnum.SUCCESSSEVENFIC)
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => {
                                    props.onRePurchase(data);
                                }}>
                                    再次购买
                                </span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                <span
                                    className='same_span'
                                    onClick={() => props.onCancelShow(data)}>
                                    取消订单
                                </span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_PAY && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => {
                                    props.onPayShow(data);
                                }}>去支付 {props.myData}</span>
                            )
                        }

                        {
                            (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND || data.orderStatus === orderStatusEnum.REFUSE_REFUND || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.COMMENTED)
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => { self.location.href = 'https://f3809eff00fcc962.kf5.com/kchat/1040267#/chatbox' }}>联系客服</span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                                <span className='same_span' onClick={props.onShow}>查看物流</span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.TAKE_DELIVERY && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className='same_span' onClick={props.onShow}>查看物流</span>
                            )
                        }
                        {
                            data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => props.onAffirm(data)}>
                                    确认收货
                                </span>
                            )
                        }
                    </div>
            }
        </div>
    );
};

let mergeList: any = NoPaginationList; // 合单支付列表
declare var window: any;
export class OrderDetailFooterNew extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props, context) {
        super(props, context)
    }
    onPush = (url) => {
        let that = this as any
        window.sessionStorage.setItem('orderData', JSON.stringify(that.props.orderDetails.lists))
        push(url, that.props)
    }
    onShow = () => {
        let that = this as any
        let data = that.props.orderDetails.lists
        push(`/logisticsDetail/${data.wayBillId}/${data.expressCompanyName}/${data.expressCompanyPhone}/${data.orderUuid}?originPageId=orderdetails`, that.props);
    }
    onAffirm = (data) => {
        let that = this as any
        alert('是否确认收货？', [
            '取消',
            {
                text: '确认收货', onClick: () => {
                    vote('order/receive/id', data, '', function (res) {
                        if (res === true) {
                            toast('确认成功');
                            data.orderStatus = orderStatusEnum.TAKE_DELIVERY;
                            push('/order/3', that.props);
                        } else {
                            toast('确认失败');
                        }
                    });
                }
            }
        ]);
    }
    onDeleteShow = (data) => {
        let that = this as any
        mergeList = new NoPaginationList({ url: 'order/payno/info', orderId: data.orderUuid });
        mergeList.fetch(d => {
            if (d === null) { // 如果为null，则没有同时下单的单子，直接删除
                that.onDelete(data);
                return false;
            }
            that.setState({
                payShow: !that.state.payShow,
                clickFlag: '删除'
            });
        });
    }
    onDelete = (data) => {
        alert('是否确认删除？', [
            '取消',
            {
                text: '确认删除', onClick: () => {
                    vote('order/delete/id', data, '', function (res) {
                        if (res === true) {
                            history.go(-1);
                        }
                    });
                }
            }
        ]);
    }
    onCancelShow = (data) => {
        let that = this as any
        mergeList = new NoPaginationList({ url: 'order/payno/info', orderId: data.orderUuid });
        mergeList.fetch(d => {
            if (d === null) { // 如果为null，则没有同时下单的单子，直接取消
                that.onCancel(data);
                return false;
            }
            that.setState({
                payShow: !that.state.payShow,
                clickFlag: '取消'
            });
        });
    }
    onCancel = (data) => {
        let that = this as any
        alert('是否确认取消？', [
            '取消',
            {
                text: '确认取消', onClick: () => {
                    vote('order/cancel/id', data, '', function (res) {
                        if (res === true) {
                            that.props.orderDetails.lists.orderStatus = -1;
                        }
                    });
                }
            }
        ]);
    }
    onRePurchase = (data) => {
        let that = this as any;
        let props = that.props.props
        let len = data.orderItems.length;
        let isBreak = false;
        // 如果是虚拟商品就跳转到确认订单 
        if (data.receiver) {// isShowAddress为true，显示地址就是非虚拟商品
            for (let i = 0; i < len; i++) {
                if (isBreak) {
                    break;
                }
                let skuId: any = data.orderItems[i].skuId;
                let num: any = data.orderItems[i].num;
                let obj: any = Object.assign({}, { data: skuId, selectNumber: num });
                addShop(obj, props.user, (isRun) => {
                    isBreak = isRun;
                    if (isRun) return;
                    let skuIdStr: any = sessionStorage.getItem('__shop');
                    if (skuIdStr) {
                        skuIdStr.indexOf(skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + skuId);
                    } else {
                        sessionStorage.setItem('__shop', skuId);
                    }
                    push('/shop', that.props);
                }, len, i);
            }
        } else {// 虚拟商品
            let skuId: any = data.orderItems[0].skuId;
            let num: any = data.orderItems[0].num;
            push('/gobuy/' + skuId + '/1/' + num + '?originType=3' + '&originPageId=orderdetails&rechargeNumber=' + that.state.rechargeNumber, that.props);
        }
    }

    render() {
        let that = this as any
        let props = that.props.props
        let data = that.props.orderDetails.lists
        const prefixCls: string = props.prefixCls;
        return (
            <div className={`${prefixCls}footerBtn`}>
                <div>
                    {
                        data.orderStatus === orderStatusEnum.CANCEL && (
                            <span
                                className='same_span'
                                onClick={() => this.onDeleteShow(data)}>
                                删除订单
                            </span>
                        )
                    }
                    {
                        data.orderStatus === orderStatusEnum.CANCEL
                        && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                            <span className={`${prefixCls}orange same_span`} onClick={() => {
                                this.onRePurchase(data);
                            }}>
                                重新购买
                            </span>
                        )
                    }
                    {
                        data.orderStatus === orderStatusEnum.WAIT_PAY && (
                            <span onClick={() => this.onCancelShow(data)} className='same_span'>
                                取消订单
                            </span>
                        )
                    }
                    {
                        data.orderStatus === orderStatusEnum.WAIT_PAY && (
                            <span className={`${prefixCls}orange same_span`} onClick={() => {
                                localStorage.setItem("payData", JSON.stringify(data))
                                push(`/payType?originPageId=orderdetails/${data.orderUuid}`, that)
                            }}>去支付 {data.myData}</span>
                        )
                    }
                    {
                        data.isDay7 == 0 || data.orderType == 1 ?
                            (data.orderStatus === orderStatusEnum.WAIT_SEND || data.orderStatus === orderStatusEnum.WAIT_RECEIVE || data.orderStatus === orderStatusEnum.APPLY_REFUND)
                            && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                                <span className={`${prefixCls}orange same_span`} onClick={() => this.onPush('/addReturnOrder?originPageId=orderdetails')}>申请退款</span>
                            ) : null
                    }
                    {
                        (data.orderStatus === orderStatusEnum.TAKE_DELIVERY || data.orderStatus === orderStatusEnum.SUCCESS || data.orderStatus === orderStatusEnum.CONFIRM_REFUND)
                        && data.orderStyles !== 1 && data.orderStyles !== 4 && (
                            <span className={`${prefixCls}orange same_span`} onClick={() => {
                                this.onRePurchase(data);
                            }}>
                                再次购买
                            </span>
                        )
                    }
                    {
                        data.orderStatus === orderStatusEnum.WAIT_RECEIVE && (
                            <span className={`${prefixCls}orange same_span`} onClick={() => this.onAffirm(data)}>
                                确认收货
                            </span>
                        )
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/orderComp/OrderStatusComp.tsx